module.exports = __webpack_public_path__ + "img/selected5-min.16ac8115.png";